import { Link } from "react-router-dom";
import ToolSidebar from "../../utils/ToolSideBar";
import "../../../css/client/ClientProjects.css";

export default function ClientProjects({ projects = [], loading, error }) {
  return (
    <div className="client-projects-shell">
      <ToolSidebar active="projects" />
      <main className="projects-page">
        <h1 className="page-title">My Projects</h1>
        {loading ? <div className="empty-state">Loading projects...</div> : error ? <div className="empty-state">{error}</div> : projects.length === 0 ? (
          <div className="empty-state">No approved projects yet.</div>
        ) : (
          <div className="projects-grid">
            {projects.map((project) => (
              <Link key={project.id} to={`/projects/${project.id}`} className="project-card">
                <div className="project-header">
                  <h3>{project.project_name || project.business_name}</h3>
                  <span className={`status status-${project.status}`}>{project.status_label}</span>
                </div>
                <p>{project.summary || "Project details are being prepared."}</p>
                <div className="progress-bar"><div className="progress-fill" style={{ width: `${project.progress_percentage || 0}%` }} /></div>
                <p className="progress-text">{project.progress_percentage || 0}% complete</p>
              </Link>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}